import collection from "@/store/collection.store-partial";
import fundModule from "@/store/game/funds/single.store";

export default {
	namespaced: true,
	modules: {
		collection,
	},
	getters: {
		spendable: (state, getters) => getters.array.find((fund) => fund.spendable),
		required: (state, getters) => getters.array.find((fund) => fund.minimum_winning_balance > 0),
		balance: (state, getters) => (type) => getters[type].balance,
		haveWinningBalances: (state, getters, rootState, rootGetters) => getters.array.every(
			(fund) => rootGetters[`game/funds/${fund.id}/hasWinningBalance`]
		),
		balancesNeeded: (state, getters, rootState, rootGetters) => getters.array.reduce(
			(total, fund) => total + rootGetters[`game/funds/${fund.id}/balanceNeeded`], 0
		),
		surplus: (state, getters, rootState) => {
			const fundBalances = getters.array.reduce(
				(total, fund) => total + (state[fund.id].balance - state[fund.id].minimum_winning_balance), 0
			);
			return fundBalances + rootState.game.balance.amount;
		},
	},
	actions: {
		configureApp: {
			root: true,
			handler({ dispatch }, configData) {
				dispatch("populate", {
					items: configData.funds,
					path: ["game", "funds"],
					module: fundModule,
				});
			},
		},
		deposit({ getters, dispatch, rootState }) {
			getters.array.forEach((fund) => {
				const amount = rootState.game.budgets[fund.budget_id].allocated;
				dispatch(`${fund.id}/deposit`, { amount });
			});
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/game/funds/list.store.js